import { atomWithStorage } from "jotai/utils";

export const previousPathAtom = atomWithStorage<string>('previousPath', '/', undefined, {
    getOnInit: true,
})